// Small pieces of the airports screen: the status tag and the delete-confirmation text.
import { Tag } from 'antd';

import type { AirportStatus } from '../../api/types';

// SHAR-458 — delete-confirm copy: warn how many active aircraft use this airport
// as homebase (they get deactivated), otherwise the original reassurance.
export function homebaseAffectedText(count?: number): string {
  return count && count > 0
    ? `${count} active aircraft ${count === 1 ? 'uses' : 'use'} this airport as homebase and will be deactivated. ` +
        `The aircraft's homebase is kept as-is for you to update. Existing bookings are unaffected.`
    : 'Existing bookings are unaffected.';
}

export function StatusTag({ status }: { status: AirportStatus }) {
  // SHAR-498/500/501 — 'removed' is the soft-delete state; it must be
  // distinguishable from Inactive, which is a deliberate operational choice.
  if (status === 'active') return <Tag color="green">Active</Tag>;
  if (status === 'removed') return <Tag color="red">Removed</Tag>;
  return <Tag color="default">Inactive</Tag>;
}
